import { useSelector, useDispatch } from 'react-redux';
import { CartoLayer, colorBins } from '@deck.gl/carto';
import { selectSourceById, updateLayer } from '@carto/react-redux';
import { useCartoLayerProps } from '@carto/react-api';
import htmlForFeature from 'utils/htmlForFeature';

export const HISTORICALBIKERVOLUME_LAYER_ID = 'historicalBikerVolumeLayer';

const layerConfig = {
  title: 'Bike Volume',
};

function HistoricalBikerVolumeLayer() {
  const dispatch = useDispatch();
  const { historicalBikerVolumeLayer } = useSelector((state) => state.carto.layers);
  const source = useSelector((state) => selectSourceById(state, historicalBikerVolumeLayer?.source));
  const cartoLayerProps = useCartoLayerProps({ source });
   const viewState = useSelector((state) => state.carto.viewState);
  const pointLineWidth = viewState.zoom >= 7 ? 2 : 1;

  if (historicalBikerVolumeLayer && source) {
    return new CartoLayer({
      ...cartoLayerProps,
      id: HISTORICALBIKERVOLUME_LAYER_ID,
      geoColumn: 'geom',
      stroked: false,
      filled: true,
      lineWidthMinPixels: pointLineWidth,
      lineWidthMaxPixels: 10,
      getLineColor: colorBins({
        attr: 'Bike_Volume',
        domain: [25, 50, 100, 200],
        colors: [
          [29, 105, 150, 64],
          [29, 105, 150, 128],
          [29, 105, 150, 192],
          [29, 105, 150, 255],
        ],
      }),
    
      coverage: 0.95,
      pickable: true,
      visible: historicalBikerVolumeLayer.visible,
      opacity: historicalBikerVolumeLayer.opacity,

      onDataLoad: (data) => {
        dispatch(
          updateLayer({
            id: HISTORICALBIKERVOLUME_LAYER_ID,
            layerAttributes: { ...layerConfig },
          })
        );
        cartoLayerProps.onDataLoad && cartoLayerProps.onDataLoad(data);
      },

      onHover: (info) => {
              if (info?.object) {
                info.object = {
                  html: htmlForFeature({
                    feature: info.object,
            }),
          };
        }
      },
    });
  }
}

export default HistoricalBikerVolumeLayer;
